export const GET_TOKEN = 'GET_TOKEN';
export const GET_USER = 'GET_USER';
export const SET_USER_PERMS = 'SET_USER_PERMS';

export const SET_PIPELINE = 'SET_PIPELINE';
export const SET_ALL_PIPELINES = 'SET_ALL_PIPELINES';

export const SET_COMPANY = 'SET_COMPANY';
export const UPDATE_CURRENT_COMPANY = 'UPDATE_CURRENT_COMPANY';

export const GET_JOBS = 'GET_JOBS';
export const SET_JOBS = 'SET_JOBS';
export const UPDATE_JOBS = 'UPDATE_JOBS';

export const GET_CURRENT_JOB = 'GET_CURRENT_JOB';
export const SET_CURRENT_JOB = 'SET_CURRENT_JOB';
export const UPDATE_CURRENT_JOB = 'UPDATE_CURRENT_JOB';
